import { Course } from 'src/models/Course'
import { DataObject } from 'src/models/DataObject'
import { LearningPath } from 'src/models/LearningPath'
import { LearningContentType } from 'src/utils/content'
import { NoAuthProvider } from 'src/network/NoAuthProvider'
import { getFeedContentData } from 'src/utils/content'
import { User } from 'src/models/User'
import moment from 'moment'
import { createQueryString, clearFalseyValues } from 'src/utils/format'

export class UserCertificate extends DataObject {
  static apiEndpoint: string = '/feed/user_certificate/'
  static OVERRIDE_MAPPINGS = {
    user: ({ user }) => (typeof user === 'object' ? User.fromData(user) : undefined),
    userId: ({ user }) => (typeof user === 'string' ? user : undefined),
    learningContent: (data) =>
      data.learningContent ? getFeedContentData(data.learningContent, data.contentType) : undefined,
  }
  static shouldUseCache: boolean = true

  static ANALYTICS_FIELDS = 'id,content_type,user,pdf_url,created_at,learning_content,custom_fields,title,public_url'

  id: string
  title: string
  createdAt: moment.Moment
  lastUpdated: moment.Moment
  certificateId: string
  contentType: LearningContentType
  learningContent?: Course | LearningPath
  pdfUrl: string // The url used to download the UserCertificate
  publicUrl: string // The url used to access the UserCertificate page which uses `pdfUrl` to download the UserCertificate
  userId: string
  user: User
  expiryDate?: moment.Moment

  static getUserCertificate = async (id: string) => {
    const { data } = await NoAuthProvider(UserCertificate.formatActionEndpoint(id, undefined).path)
    return UserCertificate.fromData(data)
  }

  static getLinkedInShareUrl = (userCertificate: UserCertificate) => {
    const linkedInDomain = 'https://www.linkedin.com/profile/add/'
    const params = {
      name: userCertificate.title,
      certUrl: userCertificate.publicUrl,
      certId: userCertificate.id,
      expirationYear: userCertificate.expiryDate ? userCertificate.expiryDate.year() : '',
      // Moment objects maintain a 0 based month -> January - 0, ... December - 11
      expirationMonth: userCertificate.expiryDate ? userCertificate.expiryDate.month() + 1 : '',
      issueYear: userCertificate.createdAt.year(),
      issueMonth: userCertificate.createdAt.month() + 1,
      organizationName: userCertificate.user.company.name,
    }
    return `${linkedInDomain}${createQueryString(clearFalseyValues(params))}`
  }
}
